import type { LifecycleEvent } from '../api/types';
import { formatDateTime } from '../utils/datetime';

const EVENT_COLOR: Record<string, string> = {
  create: 'is-success', provision: 'is-success', migrate: '',
  grace: 'is-warning', read_only: 'is-warning', suspend: 'is-danger',
  manually_lock: '', resume: 'is-success', purge: 'is-danger', warn: 'is-warning', unlock: 'is-success',
  reset_admin: 'is-warning',
};
export const EVENT_LABEL: Record<string, string> = {
  create: '创建租户', provision: '开通完成', migrate: '迁移 schema',
  grace: '进入宽限期', read_only: '进入只读', suspend: '已停服',
  manually_lock: '手动冻结', resume: '已恢复', purge: '清退', warn: '到期提醒', unlock: '已解冻',
  reset_admin: '重置 admin 密码',
};

/** detail 字段渲染：优先 message；否则把 JSONB 摊平为 "k: v · k: v" 串 */
export function summarizeDetail(detail: LifecycleEvent['detail']): string {
  if (!detail || typeof detail !== 'object') return '';
  if (typeof detail.message === 'string' && detail.message) return detail.message;
  const parts: string[] = [];
  for (const [k, v] of Object.entries(detail)) {
    if (v == null || v === '') continue;
    if (k === 'message') continue;
    const s = typeof v === 'object' ? JSON.stringify(v) : String(v);
    parts.push(`${k}: ${s}`);
  }
  return parts.join(' · ');
}

function actorTitle(hasUsername: boolean) {
  return hasUsername
    ? 'lifecycle_event.operator_id JOIN platform_admins.username 渲染。'
    : '由后台调度器写入；lifecycle_event.operator_id=NULL，UI 用 cron 占位标识。';
}

export function EventTimeline({ events, showId = false }: { events: LifecycleEvent[]; showId?: boolean }) {
  return (
    <ul className="timeline" style={{ margin: 0, paddingLeft: 24, listStyle: 'none' }}>
      {events.map((e) => {
        const actor = e.operator_username ?? 'cron';
        return (
          <li key={e.id} className="timeline__item">
            <span className={`timeline__dot ${EVENT_COLOR[e.event_type] ?? ''}`} />
            <div className="timeline__row">
              <span className="timeline__title">{EVENT_LABEL[e.event_type] ?? e.event_type}</span>
              {showId && <span className="text-mono text-xs text-muted">#{e.id}</span>}
              {e.tenant_code && (
                <span className="text-mono text-xs text-muted">{e.tenant_code}</span>
              )}
              <span className="timeline__time" title={e.occurred_at}>{formatDateTime(e.occurred_at)}</span>
            </div>
            <div className="timeline__body">
              <span className="text-muted">操作人</span>{' '}
              <span title={actorTitle(!!e.operator_username)} style={{ cursor: 'help', borderBottom: '1px dashed var(--c-border-strong)' }}>
                {actor}
              </span>
              {(e.from_status || e.to_status) && (
                <>
                  <span className="text-muted"> · </span>
                  <span className="text-xs text-mono">{e.from_status ?? '∅'} → {e.to_status ?? '∅'}</span>
                </>
              )}
              {summarizeDetail(e.detail) && (
                <>
                  <span className="text-muted"> · </span>
                  <span className="text-xs">{summarizeDetail(e.detail)}</span>
                </>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
}

export default EventTimeline;
